// No `re_scan_order_items` hook: it has no put-wall equivalent, so the engine
// treats it as a plain backend call. `finalize` is added in productFirstActions.

import {PF_SET_PROMPT, PF_SET_LOADING} from '../../../constants';
import {navigate} from '../../root_navigation';

export const putWallPostScanConfig = {
  setLoading: (dispatch, value) =>
    dispatch({type: PF_SET_LOADING, payload: value}),

  packingCam: {returnParam: 'returnToPutWall', carriesToteInput: false},

  // Uses the shared `print_ss_label` gate, so this stays inert until that field
  // is present on the product_first_scan order.
  shippingLabel: {
    navigate: (dispatch, getState, {order, orderId, remainingModules}) => {
      const settings = getState().user?.bothSettings?.data?.data;
      navigate('ShippingLabel', {
        basicinfo: order,
        isolatedComponent: true,
        returnToPutWall: true,
        currentOrderId: orderId,
        setting: settings,
        directPrintingSetting: settings?.general_setting?.print_ss_shipping_labels,
        postScanningContinue: true,
        postScanningModulesRemaining: remainingModules
      });
    }
  },

  showPrompt: (dispatch, {promptType, order, orderId, remainingModules}) =>
    dispatch({
      type: PF_SET_PROMPT,
      payload: {
        isVisible: true,
        type: promptType,
        message: {
          orderId,
          orderIncrementId: order?.increment_id,
          remainingModules,
          ...(promptType === 'PostScanVerifyShipping'
            ? {hasTracking: !!order?.tracking_num}
            : {})
        }
      }
    })
};
